import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import HeaderClient from './header-components/HeaderClient';
import HeaderAdmin from './header-components/HeaderAdmin';
import { useTextService } from '../services/useTextService';

function Header() {
    const [admin, setAdmin] = useState(false);
    const [mobile, setMobile] = useState(window.innerWidth < 700);
    const [isHome, setIsHome] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const location = useLocation();

    const { getValueByTag } = useTextService();
    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
      if (user && user.type === 'admin') {
        setAdmin(true);
      }
    }, [user]);

    useEffect(() => {
      const handleResize = () => {
        setMobile(window.innerWidth < 1100);
      };

      // Attach the event listener
      window.addEventListener('resize', handleResize);

      // Cleanup function
      return () => {
        // Remove the event listener
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    useEffect(() => {
      // Check if the current path is the home path
      setIsHome(location.pathname === '/');
    }, [location]);

    useEffect(() => {
      const handleScroll = () => {
        setScrolled(window.scrollY > 50);
      };

      // Attach the scroll event listener
      window.addEventListener('scroll', handleScroll);

      // Cleanup function
      return () => {
        // Remove the scroll event listener
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    const bannerContent = getValueByTag('header-baneris');

    return (
        <div className={`header ${isHome && !admin ? 'light' : ''}`}>
          { !admin && bannerContent && (
            <div className={`baneris ${!isHome ? 'light' : ''} ${scrolled ? 'hidden' : ''}`} dangerouslySetInnerHTML={bannerContent}></div>
          )}

          {admin ? <HeaderAdmin/> : <HeaderClient mobile={mobile}/>}
        </div>
    );
}

export default Header;